import React, {Component} from 'react';
import {RiArrowRightLine, RiArrowLeftLine} from "react-icons/ri";
import Scr2 from '../../assets/screenshot2.png';
import Scr3 from '../../assets/screenshot3.png';
import './whats_new.css';
import ScreenshotCarousel from '../../components/screenshot_carousel/ScreenshotCarousel';
import { CTA } from '../../components';

export default class WhatsNew extends Component {

  constructor(props) {
    super(props);
    this.childRef = React.createRef();
  }

  render(){
    const screenshotList = [
      {
        name: "about",
        imgSrc: Scr2,
      },
      {
        name: "hoome",
        imgSrc: Scr3,
      },
      {
        name: "book",
        imgSrc: Scr3,
      },
      {
        name: "work",
        imgSrc: Scr3,
      },
    ];
    return (
      <div className='gmc__whatsnew section__padding'>
        <div className='gmc__whatsnew-content'>
          <h1>What's More?</h1>
          <p>With the app’s reporting system, you can follow up <br />and monitor the care being delivered in real-time <br/>from anywhere in the world!</p>
          <CTA />
          <div className='gmc__whatsnew-content_slider-arrows_wrapper'>
            <div className='gmc__whatsnew-content_slider-arrows'>
              <button onClick={() => this.childRef.current.slickPrev()}><RiArrowLeftLine color="#fff" size={18} /></button>
              <button onClick={() => this.childRef.current.slickNext()}><RiArrowRightLine color="#fff" size={18} /></button>
            </div>
            
          </div>
        </div>

        <div className='gmc__whatsnew-screenshots'>
          <ScreenshotCarousel list={screenshotList} ref={this.childRef}/>
        </div>

        <div className='gmc__whatsnew-content_slider-arrows_mobile'>
            <div className='gmc__whatsnew-content_slider-arrows'>
              <button onClick={() => this.childRef.current.slickPrev()}><RiArrowLeftLine color="#fff" size={18} /></button>
              <button onClick={() => this.childRef.current.slickNext()}><RiArrowRightLine color="#fff" size={18} /></button>
            </div>
            
          </div>
      </div>
    );
  }
}